module.exports = __webpack_public_path__ + "static/pancit-canton-e877b034a42439242fbe270483457165.jpg";